import React, { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { createStructuredSelector } from "reselect";

import { selectUserCredits } from "store/users/selectors";

import { usePaymentModal } from "contexts/PaymentModalContext.jsx";

import { useOutsideClickHook } from "utils/outsideClick";
import { useStateSelector } from "utils/field";

import Dropdown from "components/Dropdown";
import Tooltip from "components/Tooltip";

import classes from "./styles.module.scss";

import SmallGreyVoltaLogo from "assets/images/icons/smallGreyVoltaLogo.svg";
import WarningIcon from "assets/images/icons/warning.svg";

const CreditsTopBar = ({ userCredits = {} }) => {
    const history = useHistory();
    const { dispatch } = usePaymentModal();
    const dropRef = useOutsideClickHook(() => setIsDropdownOpen(false));

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const isUserVerified = useStateSelector("user.isUserVerified");

    const { credits = 0, total = 0 } = userCredits;

    return (
        <div className={classes.creditsTopBarContainer} ref={dropRef}>
            {total > 0 && (
                <>
                    <img
                        src={WarningIcon}
                        alt="warning icon"
                        className={classes.legacyCreditsIcon}
                        data-html
                        data-tip={`<span style="display:block;max-width:14rem;white-space: pre-line;">Your account has legacy credits. &#xa;&#xa; You have ${total} legacy credits. You may spend these on parametric analyses or transition them to the new credit system. Legacy credits may not be used to unlock Insights until transferred to the new credit system.</span>`}
                        data-for="creditsWarningTip"
                        onClick={() => history.push("/user/transactions")}
                    />
                    <Tooltip id="creditsWarningTip" />
                </>
            )}
            <div className={classes.creditsTopBarWrapper} onClick={() => setIsDropdownOpen(true)}>
                <span className={classes.creditsTopBarText}>Credits: {credits}</span>
                <img src={SmallGreyVoltaLogo} alt="small grey logo" />
            </div>
            <Dropdown
                open={isDropdownOpen}
                className={classes.creditsDropdown}
                options={[
                    {
                        label: "Buy More",
                        onClick: () => {
                            dispatch({ type: "OPEN" });
                            setIsDropdownOpen(false);
                        },
                        disabled: !isUserVerified,
                    },
                    {
                        label: "Transactions",
                        onClick: () => {
                            history.push("/user/transactions");
                            setIsDropdownOpen(false);
                        },
                    },
                    {
                        label: "Pricing",
                        onClick: () => {
                            history.push("/pricing");
                            setIsDropdownOpen(false);
                        },
                    },
                ]}
            />
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    userCredits: selectUserCredits,
});

export default connect(mapStateToProps, null)(CreditsTopBar);
